export const UNCLE_QUOTES = [
  "เอ้า... นั่งลงๆ พนมมือเข้าลูกหลาน...",
  "ไหนดูซิ... โหงวเฮ้งใช้ได้ แต่หน้าผากกว้างไปนิดนะเรา",
  "ปีนี้ชงหรือเปล่าเนี่ย? เดี๋ยวลุงส่องแป๊บ...",
  "อืม... เส้นลายมือยุ่งเหยิงเหมือนสายไฟลงดินเลยนะ",
  "จิตต้องนิ่งนะ... อย่าเพิ่งคิดเรื่องหวยงวดนี้",
];

export const UNCLE_QUOTES_EN = [
  "Come... sit down, hands together...",
  "Let me see... your horoscope looks good, but your forehead is a bit wide isn't it?",
  "Is this your zodiac year? Let Uncle take a look...",
  "Hmm... your palm lines are as messy as tangled wires",
  "Your mind must be calm... don't think about the lottery yet",
];

export const UNCLE_QUOTES_DE = [
  "Komm... setz dich, Haende zusammen...",
  "Lass mich sehen... dein Horoskop sieht gut aus, aber deine Stirn ist etwas breit, nicht wahr?",
  "Ist das dein Tierkreisjahr? Lass Onkel mal schauen...",
  "Hmm... deine Handlinien sind so unordentlich wie verwickelte Kabel",
  "Dein Geist muss ruhig sein... denk noch nicht an das Lotto",
];
